import { pathsConfig } from './paths.config';

const routes = [
  {
    key: pathsConfig.resetPassword.key,
    name: pathsConfig.resetPassword.name,
    path: pathsConfig.resetPassword.path,
    component: pathsConfig.resetPassword.component,
  },
  {
    key: pathsConfig.forgotpassword.key,
    name: pathsConfig.forgotpassword.name,
    path: pathsConfig.forgotpassword.path,
    component: pathsConfig.forgotpassword.component,
  },
];

const routesLayout = [
];

export { routes, routesLayout };
